import React from "react";
import accountManagement from "./accountManagement";
import fraudriskManegement from "./fraud&riskManegement";
import voucherManegement from "./voucherManagement";
import currencyManagement from "./currencyManagement";
import WalletManagement from "./walletManagement";
import LimitManagement from "./limitManagement";
import kycManagement from "./KycManagement";
import feeManagement from "./feeManagement";
import invoiceManagement from "./invoiceManagement";
import gateWayServiceManagement from "./gateWayServiceManagement";
import gatewayManagement from "./gatewayManagement";
import settings from "./settings";
import userManagement from "./userManagement";
import SettlementManagement from "./settlementManagement";
import cashLifting from "./cashLifting";
import withdrawEMoney from "./withdrawEMoney";
import agentDealerMapping from "./agentDealerMapping";

// Admin
import walletOwnerManagement from "./walletOwnerManagement";
import adminFraudRiskManagement from "./adminFraudRiskManagement";
import adminCurrencyManagement from "./adminCurrencyManagement";
import adminWalletManagement from "./adminWalletManagement";
import adminKycManagement from "./adminKycManagement";
import adminFeeMaster from "./adminFeeMaster";
import adminSetting from "./adminSetting";
import userManagementAdmin from "./userManagementAdmin";

// Dealer
import dealerProfile from "./dealerProfile";
import dealerDsrManagement from "./dealerDsrManagement";
import dealerCashLifting from "./dealerCashLifting";
import dealerWithdrawEMoney from "./dealerWithdrawEMoney";
import dealerPendingRequest from "./dealerPendingRequest";
import dealerWalletManagement from "./dealerWalletManagement";
import dealerUserManagement from "./dealerUserManagement";
import dealerAgentMaster from "./dealerAgentMaster";

//Bank
import bankModulebankMaster from "./bankModulebankMaster";
import bankModulewithdrawEMoney from "./bankModulewithdrawEMoney";
import bankModulecashLifting from "./bankModulecashLifting";
import bankModuleuserManagement from "./bankModuleuserManagement";
import adminTransactionManagement from "./adminTransactionManagement";
import adminGatewayManagement from "./adminGatewayManagement";
import AdminUserMgmt from "./adminUserManagement";

function sidebarRoutes() {
  let sidebarRoutes = [];
  let a = accountManagement();
  let b = fraudriskManegement();
  let c = voucherManegement();
  let d = currencyManagement();
  let e = WalletManagement();
  let f = LimitManagement();
  let g = kycManagement();
  let h = feeManagement();
  let i = invoiceManagement();
  let j = gateWayServiceManagement();
  let l = gatewayManagement();

  let k = walletOwnerManagement();
  let m = adminFraudRiskManagement();
  let n = adminCurrencyManagement();
  let o = adminWalletManagement();
  let p = adminKycManagement();
  let q = adminFeeMaster();
  let r = adminSetting();
  let s = settings();
  let t = userManagement();
  let u = SettlementManagement();
  let a8 = cashLifting();
  let a9 = withdrawEMoney();
  let a10 = agentDealerMapping();
  let a11 = adminTransactionManagement();
  let a12 = adminGatewayManagement()

  // Dealer

  let v = dealerProfile();
  let w = dealerDsrManagement();
  let x = dealerCashLifting();
  let y = dealerWithdrawEMoney();
  let z = dealerPendingRequest();
  let a1 = dealerWalletManagement();
  let a2 = dealerUserManagement();
  let a3 = bankModulebankMaster();
  let a4 = bankModulecashLifting();
  let a5 = bankModulewithdrawEMoney();
  let a6 = bankModuleuserManagement();
  let a7 = dealerAgentMaster();

  //Admin
  let a13 = userManagementAdmin()
  let a14 = AdminUserMgmt()

  sidebarRoutes = [
    ...a,
    ...b,
    ...c,
    ...d,
    ...e,
    ...f,
    ...g,
    ...h,
    ...i,
    ...j,
    ...k,
    ...l,
    ...m,
    ...n,
    ...o,
    ...p,
    ...q,
    ...r,
    ...s,
    ...t,
    ...u,
    ...v,
    ...w,
    ...x,
    ...y,
    ...z,
    ...a1,
    ...a2,
    ...a3,
    ...a4,
    ...a5,
    ...a6,
    ...a7,
    ...a8,
    ...a9,
    ...a10,
    ...a11,
    ...a12,
    ...a13,
    ...a14
  ];
  return sidebarRoutes;
}

export default sidebarRoutes;
